import { useRef, useState } from 'react';
import { Popover } from '@teachstonellc/component-library';
import { IconInfo } from 'components/icons';

export default function InfoPopover({
  label,
  content
}: {
  label: string;
  content: string;
}) {
  const trigger = useRef<HTMLButtonElement>(null);
  const [rect, setRect] = useState<DOMRect | null>(null);

  function close() {
    setRect(null);
    trigger.current?.focus();
  }

  return (
    <>
      <button
        ref={trigger}
        type="button"
        aria-label={label}
        aria-haspopup="dialog"
        aria-expanded={!!rect}
        onClick={event =>
          setRect(rect ? null : event.currentTarget.getBoundingClientRect())
        }
      >
        <IconInfo />
      </button>
      {rect && (
        <Popover
          open
          rect={rect}
          onClose={close}
          onEscapeKeyDown={close}
          contentAriaLabel={label}
          className="max-w-xs p-4"
        >
          {content}
        </Popover>
      )}
    </>
  );
}
